"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.permissionSet = exports.Permission = void 0;
const PlexUserRelationState_1 = require("../schema/PlexUserRelationState");
/*
Granular permissions related to plexes and plex content.
*/
var Permission;
(function (Permission) {
    // Name, description
    Permission["READ_PLEX_INFO"] = "READ_PLEX_INFO";
    Permission["WRITE_PLEX_INFO"] = "WRITE_PLEX_INFO";
    // Subscribe to plex
    Permission["SUBSCRIBE_AS_PLEX_READER"] = "SUBSCRIBE_AS_PLEX_READER";
    // Plex administration
    Permission["READ_PLEX_SETTINGS"] = "READ_PLEX_SETTINGS";
    Permission["WRITE_PLEX_SETTINGS"] = "WRITE_PLEX_SETTINGS";
    Permission["READ_PLEX_ANALYTICS"] = "READ_PLEX_ANALYTICS";
    // Plex posts
    Permission["READ_OWN_DRAFT_PLEX_POST"] = "READ_OWN_DRAFT_PLEX_POST";
    Permission["READ_INTERNAL_PLEX_POST"] = "READ_INTERNAL_PLEX_POST";
    Permission["READ_PUBLISHED_PLEX_POST"] = "READ_PUBLISHED_PLEX_POST";
    Permission["READ_POST_ANALYTICS"] = "READ_POST_ANALYTICS";
    Permission["CREATE_PLEX_POST"] = "CREATE_PLEX_POST";
    Permission["EDIT_OWN_DRAFT_POST"] = "EDIT_OWN_DRAFT_POST";
    Permission["EDIT_OWN_INTERNAL_POST"] = "EDIT_OWN_INTERNAL_POST";
    Permission["EDIT_INTERNAL_POST"] = "EDIT_INTERNAL_POST";
    Permission["EDIT_PUBLISHED_POST"] = "EDIT_PUBLISHED_POST";
    Permission["CHANGE_POST_PUBLISH_STATUS"] = "CHANGE_POST_PUBLISH_STATUS";
    Permission["DELETE_OWN_DRAFT_POST"] = "DELETE_OWN_DRAFT_POST";
    Permission["DELETE_OWN_INTERNAL_POST"] = "DELETE_OWN_INTERNAL_POST";
    Permission["DELETE_INTERNAL_POST"] = "DELETE_INTERNAL_POST";
    Permission["DELETE_PUBLISHED_POST"] = "DELETE_PUBLISHED_POST";
    Permission["READ_COMMENT"] = "READ_COMMENT";
    Permission["CREATE_COMMENT"] = "CREATE_COMMENT";
    Permission["EDIT_OWN_COMMENT"] = "EDIT_OWN_COMMENT";
    Permission["DELETE_OWN_COMMENT"] = "DELETE_OWN_COMMENT";
    Permission["DELETE_COMMENT"] = "DELETE_COMMENT";
    // Plex question templates
    Permission["READ_PLEX_QUESTION_TEMPLATE"] = "READ_PLEX_QUESTION_TEMPLATE";
    Permission["MANAGE_PLEX_QUESTION_TEMPLATE"] = "MANAGE_PLEX_QUESTION_TEMPLATE";
    // Plex questions
    Permission["READ_OWN_DRAFT_QUESTION"] = "READ_OWN_DRAFT_QUESTION";
    Permission["READ_OWN_INTERNAL_QUESTION"] = "READ_OWN_INTERNAL_QUESTION";
    Permission["READ_INTERNAL_QUESTION"] = "READ_INTERNAL_QUESTION";
    Permission["READ_PUBLISHED_QUESTION"] = "READ_PUBLISHED_QUESTION";
    Permission["READ_QUESTION_ANALYTICS"] = "READ_QUESTION_ANALYTICS";
    Permission["CREATE_PLEX_QUESTION"] = "CREATE_PLEX_QUESTION";
    Permission["EDIT_OWN_DRAFT_QUESTION"] = "EDIT_OWN_DRAFT_QUESTION";
    Permission["EDIT_OWN_INTERNAL_QUESTION"] = "EDIT_OWN_INTERNAL_QUESTION";
    Permission["EDIT_INTERNAL_QUESTION"] = "EDIT_INTERNAL_QUESTION";
    Permission["EDIT_PUBLISHED_QUESTION"] = "EDIT_PUBLISHED_QUESTION";
    Permission["CHANGE_QUESTION_PUBLISH_STATUS"] = "CHANGE_QUESTION_PUBLISH_STATUS";
    Permission["DELETE_OWN_DRAFT_QUESTION"] = "DELETE_OWN_DRAFT_QUESTION";
    Permission["DELETE_OWN_INTERNAL_QUESTION"] = "DELETE_OWN_INTERNAL_QUESTION";
    Permission["DELETE_INTERNAL_QUESTION"] = "DELETE_INTERNAL_QUESTION";
    Permission["DELETE_PUBLISHED_QUESTION"] = "DELETE_PUBLISHED_QUESTION";
    // Question answers
    Permission["READ_OWN_DRAFT_ANSWER"] = "READ_OWN_DRAFT_ANSWER";
    Permission["READ_NON_DRAFT_ANSWER"] = "READ_NON_DRAFT_ANSWER";
    Permission["CREATE_PLEX_ANSWER"] = "CREATE_PLEX_ANSWER";
    Permission["EDIT_OWN_DRAFT_ANSWER"] = "WRITE_PLEX_ANSWER";
    Permission["EDIT_OWN_NON_APPROVED_ANSWER"] = "EDIT_OWN_NON_APPROVED_ANSWER";
    Permission["EDIT_NON_APPROVED_ANSWER"] = "EDIT_NON_APPROVED_ANSWER";
    Permission["EDIT_APPROVED_ANSWER"] = "EDIT_APPROVED_ANSWER";
    Permission["APPROVE_PLEX_ANSWER"] = "APPROVE_PLEX_ANSWER";
    Permission["DELETE_OWN_DRAFT_ANSWER"] = "DELETE_OWN_DRAFT_ANSWER";
    Permission["DELETE_OWN_NON_APPROVED_ANSWER"] = "DELETE_OWN_NON_APPROVED_ANSWER";
    Permission["DELETE_NON_APPROVED_ANSWER"] = "DELETE_NON_APPROVED_ANSWER";
    Permission["DELETE_APPROVED_ANSWER"] = "DELETE_ANSWER";
    // Tasks
    Permission["CREATE_PLEX_TASK"] = "CREATE_PLEX_TASK";
    Permission["READ_OWN_DRAFT_PLEX_TASK"] = "READ_OWN_DRAFT_PLEX_TASK";
    Permission["READ_OWN_INTERNAL_PLEX_TASK"] = "READ_OWN_INTERNAL_PLEX_TASK";
    Permission["READ_INTERNAL_PLEX_TASK"] = "READ_INTERNAL_PLEX_TASK";
    Permission["READ_PUBLISHED_PLEX_TASK"] = "READ_PUBLISHED_PLEX_TASK";
    Permission["EDIT_OWN_DRAFT_TASK"] = "EDIT_OWN_DRAFT_TASK";
    Permission["EDIT_OWN_INTERNAL_TASK"] = "EDIT_OWN_INTERNAL_TASK";
    Permission["EDIT_INTERNAL_TASK"] = "EDIT_INTERNAL_TASK";
    Permission["EDIT_PUBLISHED_TASK"] = "EDIT_PUBLISHED_TASK";
    Permission["DELETE_OWN_DRAFT_TASK"] = "DELETE_OWN_DRAFT_TASK";
    Permission["DELETE_OWN_INTERNAL_TASK"] = "DELETE_OWN_INTERNAL_TASK";
    Permission["DELETE_INTERNAL_TASK"] = "DELETE_INTERNAL_TASK";
    Permission["DELETE_PUBLISHED_TASK"] = "DELETE_PUBLISHED_TASK";
    // Processes
    Permission["CREATE_FACT_REVIEW_PROCESS"] = "CREATE_FACT_REVIEW_PROCESS";
    Permission["UPDATE_FACT_REVIEW_PROCESS"] = "UPDATE_FACT_REVIEW_PROCESS";
    Permission["DELETE_PLEX"] = "DELETE_PLEX";
    Permission["REACT_TO_READABLE_CONTENT"] = "REACT_TO_READABLE_CONTENT";
    Permission["READ_BOARDS"] = "READ_BOARDS";
    Permission["CREATE_PLEX_BOARD"] = "CREATE_PLEX_BOARD";
    Permission["EDIT_BOARD"] = "EDIT_BOARD";
    Permission["CHANGE_BOARD_ORDER"] = "CHANGE_BOARD_ORDER";
    Permission["CHANGE_QUESTION_BOARD"] = "CHANGE_QUESTION_BOARD";
    Permission["DELETE_BOARD"] = "DELETE_BOARD";
    Permission["CHANGE_QUESTION_ORDER"] = "CHANGE_QUESTION_ORDER";
})(Permission = exports.Permission || (exports.Permission = {}));
const OWNER_PERMISSIONS = new Set([
    Permission.READ_PLEX_INFO,
    Permission.WRITE_PLEX_INFO,
    Permission.READ_PLEX_SETTINGS,
    Permission.WRITE_PLEX_SETTINGS,
    Permission.READ_PLEX_ANALYTICS,
    Permission.READ_PUBLISHED_PLEX_POST,
    Permission.READ_POST_ANALYTICS,
    Permission.READ_INTERNAL_PLEX_POST,
    Permission.READ_OWN_DRAFT_PLEX_POST,
    Permission.CREATE_PLEX_POST,
    Permission.EDIT_OWN_DRAFT_POST,
    Permission.EDIT_OWN_INTERNAL_POST,
    Permission.EDIT_INTERNAL_POST,
    Permission.EDIT_PUBLISHED_POST,
    Permission.CHANGE_POST_PUBLISH_STATUS,
    Permission.DELETE_OWN_DRAFT_POST,
    Permission.DELETE_OWN_INTERNAL_POST,
    Permission.DELETE_INTERNAL_POST,
    Permission.DELETE_PUBLISHED_POST,
    Permission.READ_PUBLISHED_PLEX_TASK,
    Permission.READ_INTERNAL_PLEX_TASK,
    Permission.READ_OWN_INTERNAL_PLEX_TASK,
    Permission.READ_OWN_DRAFT_PLEX_TASK,
    Permission.CREATE_PLEX_TASK,
    Permission.EDIT_OWN_DRAFT_TASK,
    Permission.EDIT_OWN_INTERNAL_TASK,
    Permission.EDIT_INTERNAL_TASK,
    Permission.EDIT_PUBLISHED_TASK,
    Permission.READ_PLEX_QUESTION_TEMPLATE,
    Permission.MANAGE_PLEX_QUESTION_TEMPLATE,
    Permission.READ_OWN_DRAFT_QUESTION,
    Permission.READ_OWN_INTERNAL_QUESTION,
    Permission.READ_INTERNAL_QUESTION,
    Permission.READ_PUBLISHED_QUESTION,
    Permission.READ_QUESTION_ANALYTICS,
    Permission.CREATE_PLEX_QUESTION,
    Permission.EDIT_OWN_DRAFT_QUESTION,
    Permission.EDIT_OWN_INTERNAL_QUESTION,
    Permission.EDIT_INTERNAL_QUESTION,
    Permission.EDIT_PUBLISHED_QUESTION,
    Permission.CHANGE_QUESTION_PUBLISH_STATUS,
    Permission.DELETE_OWN_DRAFT_QUESTION,
    Permission.DELETE_OWN_INTERNAL_QUESTION,
    Permission.DELETE_INTERNAL_QUESTION,
    Permission.DELETE_PUBLISHED_QUESTION,
    Permission.READ_OWN_DRAFT_ANSWER,
    Permission.READ_NON_DRAFT_ANSWER,
    Permission.CREATE_PLEX_ANSWER,
    Permission.EDIT_OWN_DRAFT_ANSWER,
    Permission.EDIT_OWN_NON_APPROVED_ANSWER,
    Permission.EDIT_NON_APPROVED_ANSWER,
    Permission.EDIT_APPROVED_ANSWER,
    Permission.REACT_TO_READABLE_CONTENT,
    Permission.APPROVE_PLEX_ANSWER,
    Permission.DELETE_OWN_DRAFT_ANSWER,
    Permission.DELETE_OWN_NON_APPROVED_ANSWER,
    Permission.DELETE_NON_APPROVED_ANSWER,
    Permission.DELETE_APPROVED_ANSWER,
    Permission.READ_COMMENT,
    Permission.CREATE_COMMENT,
    Permission.EDIT_OWN_COMMENT,
    Permission.DELETE_OWN_COMMENT,
    Permission.DELETE_COMMENT,
    Permission.DELETE_PLEX,
    Permission.SUBSCRIBE_AS_PLEX_READER,
    Permission.READ_BOARDS,
    Permission.CREATE_PLEX_BOARD,
    Permission.EDIT_BOARD,
    Permission.CHANGE_BOARD_ORDER,
    Permission.CHANGE_QUESTION_BOARD,
    Permission.DELETE_BOARD,
    Permission.CHANGE_QUESTION_ORDER,
    Permission.CREATE_FACT_REVIEW_PROCESS,
    Permission.UPDATE_FACT_REVIEW_PROCESS,
    Permission.DELETE_OWN_DRAFT_TASK,
    Permission.DELETE_OWN_INTERNAL_TASK,
    Permission.DELETE_INTERNAL_TASK,
    Permission.DELETE_PUBLISHED_TASK,
]);
const MANAGER_PERMISSIONS = new Set([
    Permission.READ_PLEX_INFO,
    Permission.WRITE_PLEX_INFO,
    Permission.READ_PLEX_SETTINGS,
    Permission.WRITE_PLEX_SETTINGS,
    Permission.READ_PLEX_ANALYTICS,
    Permission.READ_PUBLISHED_PLEX_POST,
    Permission.READ_POST_ANALYTICS,
    Permission.READ_INTERNAL_PLEX_POST,
    Permission.READ_OWN_DRAFT_PLEX_POST,
    Permission.CREATE_PLEX_POST,
    Permission.EDIT_OWN_DRAFT_POST,
    Permission.EDIT_OWN_INTERNAL_POST,
    Permission.EDIT_INTERNAL_POST,
    Permission.EDIT_PUBLISHED_POST,
    Permission.CHANGE_POST_PUBLISH_STATUS,
    Permission.DELETE_OWN_DRAFT_POST,
    Permission.DELETE_OWN_INTERNAL_POST,
    Permission.DELETE_INTERNAL_POST,
    Permission.DELETE_PUBLISHED_POST,
    Permission.READ_PUBLISHED_PLEX_TASK,
    Permission.READ_INTERNAL_PLEX_TASK,
    Permission.READ_OWN_INTERNAL_PLEX_TASK,
    Permission.READ_OWN_DRAFT_PLEX_TASK,
    Permission.CREATE_PLEX_TASK,
    Permission.EDIT_OWN_DRAFT_TASK,
    Permission.EDIT_OWN_INTERNAL_TASK,
    Permission.EDIT_INTERNAL_TASK,
    Permission.EDIT_PUBLISHED_TASK,
    Permission.READ_OWN_INTERNAL_QUESTION,
    Permission.READ_PLEX_QUESTION_TEMPLATE,
    Permission.MANAGE_PLEX_QUESTION_TEMPLATE,
    Permission.READ_OWN_DRAFT_QUESTION,
    Permission.READ_INTERNAL_QUESTION,
    Permission.READ_PUBLISHED_QUESTION,
    Permission.READ_QUESTION_ANALYTICS,
    Permission.CREATE_PLEX_QUESTION,
    Permission.EDIT_OWN_DRAFT_QUESTION,
    Permission.EDIT_OWN_INTERNAL_QUESTION,
    Permission.EDIT_INTERNAL_QUESTION,
    Permission.EDIT_PUBLISHED_QUESTION,
    Permission.CHANGE_QUESTION_PUBLISH_STATUS,
    Permission.DELETE_OWN_DRAFT_QUESTION,
    Permission.DELETE_OWN_INTERNAL_QUESTION,
    Permission.DELETE_INTERNAL_QUESTION,
    Permission.DELETE_PUBLISHED_QUESTION,
    Permission.READ_OWN_DRAFT_ANSWER,
    Permission.READ_NON_DRAFT_ANSWER,
    Permission.CREATE_PLEX_ANSWER,
    Permission.EDIT_OWN_DRAFT_ANSWER,
    Permission.EDIT_OWN_NON_APPROVED_ANSWER,
    Permission.EDIT_NON_APPROVED_ANSWER,
    Permission.EDIT_APPROVED_ANSWER,
    Permission.REACT_TO_READABLE_CONTENT,
    Permission.APPROVE_PLEX_ANSWER,
    Permission.DELETE_OWN_DRAFT_ANSWER,
    Permission.DELETE_OWN_NON_APPROVED_ANSWER,
    Permission.DELETE_NON_APPROVED_ANSWER,
    Permission.DELETE_APPROVED_ANSWER,
    Permission.READ_COMMENT,
    Permission.CREATE_COMMENT,
    Permission.EDIT_OWN_COMMENT,
    Permission.DELETE_OWN_COMMENT,
    Permission.DELETE_COMMENT,
    Permission.SUBSCRIBE_AS_PLEX_READER,
    Permission.READ_BOARDS,
    Permission.CREATE_PLEX_BOARD,
    Permission.EDIT_BOARD,
    Permission.CHANGE_BOARD_ORDER,
    Permission.CHANGE_QUESTION_BOARD,
    Permission.DELETE_BOARD,
    Permission.CHANGE_QUESTION_ORDER,
    Permission.CREATE_FACT_REVIEW_PROCESS,
    Permission.UPDATE_FACT_REVIEW_PROCESS,
    Permission.DELETE_OWN_DRAFT_TASK,
    Permission.DELETE_OWN_INTERNAL_TASK,
    Permission.DELETE_INTERNAL_TASK,
    Permission.DELETE_PUBLISHED_TASK,
]);
const MEMBER_PERMISSIONS = new Set([
    Permission.READ_PLEX_INFO,
    Permission.READ_PUBLISHED_PLEX_POST,
    Permission.READ_INTERNAL_PLEX_POST,
    Permission.READ_OWN_DRAFT_PLEX_POST,
    Permission.CREATE_PLEX_POST,
    Permission.EDIT_OWN_DRAFT_POST,
    Permission.EDIT_OWN_INTERNAL_POST,
    Permission.DELETE_OWN_DRAFT_POST,
    Permission.DELETE_OWN_INTERNAL_POST,
    Permission.READ_PUBLISHED_PLEX_TASK,
    Permission.READ_INTERNAL_PLEX_TASK,
    Permission.READ_OWN_INTERNAL_PLEX_TASK,
    Permission.READ_OWN_DRAFT_PLEX_TASK,
    Permission.CREATE_PLEX_TASK,
    Permission.EDIT_OWN_DRAFT_TASK,
    Permission.EDIT_OWN_INTERNAL_TASK,
    Permission.EDIT_INTERNAL_TASK,
    Permission.EDIT_PUBLISHED_TASK,
    Permission.READ_PLEX_QUESTION_TEMPLATE,
    Permission.READ_OWN_DRAFT_QUESTION,
    Permission.READ_OWN_INTERNAL_QUESTION,
    Permission.READ_INTERNAL_QUESTION,
    Permission.READ_PUBLISHED_QUESTION,
    Permission.CREATE_PLEX_QUESTION,
    Permission.EDIT_OWN_DRAFT_QUESTION,
    Permission.EDIT_OWN_INTERNAL_QUESTION,
    Permission.DELETE_OWN_DRAFT_QUESTION,
    Permission.DELETE_OWN_INTERNAL_QUESTION,
    Permission.READ_OWN_DRAFT_ANSWER,
    Permission.READ_NON_DRAFT_ANSWER,
    Permission.CREATE_PLEX_ANSWER,
    Permission.EDIT_OWN_DRAFT_ANSWER,
    Permission.EDIT_OWN_NON_APPROVED_ANSWER,
    Permission.REACT_TO_READABLE_CONTENT,
    Permission.DELETE_OWN_DRAFT_ANSWER,
    Permission.DELETE_OWN_NON_APPROVED_ANSWER,
    Permission.READ_COMMENT,
    Permission.CREATE_COMMENT,
    Permission.EDIT_OWN_COMMENT,
    Permission.DELETE_OWN_COMMENT,
    Permission.SUBSCRIBE_AS_PLEX_READER,
    Permission.READ_BOARDS,
    Permission.DELETE_OWN_DRAFT_TASK,
    Permission.DELETE_OWN_INTERNAL_TASK,
]);
const SUBSCRIBER_PERMISSIONS = new Set([
    Permission.READ_PLEX_INFO,
    Permission.READ_PUBLISHED_PLEX_POST,
    Permission.READ_OWN_DRAFT_PLEX_POST,
    Permission.READ_PUBLISHED_PLEX_TASK,
    Permission.READ_OWN_DRAFT_PLEX_TASK,
    Permission.READ_OWN_INTERNAL_PLEX_TASK,
    Permission.READ_OWN_DRAFT_QUESTION,
    Permission.READ_OWN_INTERNAL_QUESTION,
    Permission.READ_PUBLISHED_QUESTION,
    Permission.CREATE_PLEX_QUESTION,
    Permission.EDIT_OWN_DRAFT_QUESTION,
    Permission.EDIT_OWN_INTERNAL_QUESTION,
    Permission.DELETE_OWN_DRAFT_QUESTION,
    Permission.DELETE_OWN_INTERNAL_QUESTION,
    Permission.READ_COMMENT,
    Permission.CREATE_COMMENT,
    Permission.EDIT_OWN_COMMENT,
    Permission.DELETE_OWN_COMMENT,
    Permission.READ_OWN_DRAFT_ANSWER,
    Permission.READ_NON_DRAFT_ANSWER,
    Permission.CREATE_PLEX_ANSWER,
    Permission.EDIT_OWN_DRAFT_ANSWER,
    Permission.EDIT_OWN_NON_APPROVED_ANSWER,
    Permission.REACT_TO_READABLE_CONTENT,
    Permission.SUBSCRIBE_AS_PLEX_READER,
    Permission.READ_BOARDS,
    Permission.CHANGE_QUESTION_BOARD,
    Permission.DELETE_OWN_DRAFT_TASK,
    Permission.DELETE_OWN_INTERNAL_TASK,
]);
function permissionSet(plexUserRelationState) {
    switch (plexUserRelationState) {
        case PlexUserRelationState_1.PlexUserRelationState.Owner:
            return OWNER_PERMISSIONS;
        case PlexUserRelationState_1.PlexUserRelationState.Manager:
            return MANAGER_PERMISSIONS;
        case PlexUserRelationState_1.PlexUserRelationState.Member:
            return MEMBER_PERMISSIONS;
        case PlexUserRelationState_1.PlexUserRelationState.Subscriber:
            return SUBSCRIBER_PERMISSIONS;
        case PlexUserRelationState_1.PlexUserRelationState.SameDomainUser:
            return SUBSCRIBER_PERMISSIONS;
        case PlexUserRelationState_1.PlexUserRelationState.NoRelation:
            return new Set([]);
    }
}
exports.permissionSet = permissionSet;
//# sourceMappingURL=plex.js.map